import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import {TranslateService} from '@ngx-translate/core';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-enetassess',
  templateUrl: './enetassess.component.html',
  styleUrls: ['./enetassess.component.scss']
})
export class EnetassessComponent implements OnInit {

  public logo = "";
  public exisitingLangauge = "en";
  public languageSelected = "en";
  public exams = [];
  public currentExam = 0;
  public isLoaded = false;
  private _loadInterval = null;
  private _initInterval = null;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    this.logo = "https://cnavt.org/img/svg/logo.svg";

    const isMock = this.dataSvc.checkMockDetails();
    var examCompleteMsg = localStorage.getItem("exam-complete-msg");
    if (examCompleteMsg != null && examCompleteMsg != undefined) {
      localStorage.removeItem("exam-complete-msg");
    }

    this.dataSvc.showLoading("Reloading exam data...");   
    this._loadInterval = setInterval( () => {
      if(!this.dataSvc.syncingConfig && this.dataSvc.syncItems != null && this.dataSvc.syncItems.length > 0){
        this.dataSvc.attemptLoginLocally();
        this.validateLoadedExamState(isMock);
        clearInterval(this._loadInterval);
      }
    }, 2000);

    this.exisitingLangauge = localStorage.getItem("userslanguage");
    if (this.exisitingLangauge !== null && this.exisitingLangauge !== undefined && this.exisitingLangauge !== "") {
      this.dataSvc.changeLangauge(this.exisitingLangauge);
      this.languageSelected = this.exisitingLangauge;
    }
    else {
      this.translate.setDefaultLang("en");
      this.translate.use("en");
      this.exisitingLangauge = "en";
    }

    this.isLoaded = true;
  }

  ngOnInit() {
    this.clearExams();
    this._initInterval = setInterval( () => {
      if(!this.dataSvc.syncingConfig && this.dataSvc.syncItems != null && this.dataSvc.syncItems.length > 0){
        this.onInit();
        clearInterval(this._initInterval);
      }
    }, 2000);
  }

  clearExams() {
    this.exams = [];
  }

  onInit() {
    if (!this.hasLoadedExamState()) {
      return;
    }

    var selLangauge = (<HTMLSelectElement>document.getElementById("selLangauge"));
    if (selLangauge !== null && selLangauge !== undefined) {
      selLangauge.value = this.exisitingLangauge.toString();
    }
    this.exams = this.dataSvc.currentUser.Exams; //.filter(x => (x.Completed == null || x.Completed == undefined || !x.Completed) && x.Status < 5);
    for (var exam of this.exams) {
      if (exam.Completed == null || exam.Completed == undefined || !exam.Completed && exam.Status < 5) {
        let index = this.exams.findIndex(x => x === exam && !x.Session.IsCandidateOralPrep);
        if (index >= 0) {
          this.currentExam = index;
          return;
        }
      }
    }
    this.isLoaded = true;
  }

  private hasLoadedExamState() {
    return this.dataSvc.currentUser != null
      && this.dataSvc.currentUser.ScheduleCandidate != null
      && this.dataSvc.currentUser.Exams != null
      && this.dataSvc.currentUser.Exams.length > 0;
  }

  private validateLoadedExamState(isMock) {
    const enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";

    if (!this.hasLoadedExamState()) {
      if(isMock !== null && isMock !== undefined){
        this.generalSvc.logoutMockUser(isMock.MockId);
      }
      else if(this.dataSvc.assessorExam){
        this.generalSvc.logoutAssessor();
      }
      else{
        this.generalSvc.logoutUser(enetsecure);
      }

      return;
    }

    if (this.dataSvc.currentUser.Exams.filter(x => x.Completed != true).length == 0) {
      if(isMock !== null && isMock !== undefined){
        this.generalSvc.logoutMockUser(isMock.MockId);
      }
      else{
        this.generalSvc.logoutUser(enetsecure);
      }
    }
  }
  changeLangauge(language){
    localStorage.setItem("userslanguage", language.toString());
    this.translate.setDefaultLang(language.toString());
    this.translate.use(language.toString());
    this.languageSelected = language.toString();  
  }
  

  launchExam(examIndex) {
    this.dataSvc.setCurrentExam(examIndex);
    this.dataSvc.setCurrentAssessment();
    this.dataSvc.setCurrentQuestion();
    this.dataSvc.pulseTimeLog("Start");
    this.generalSvc.launchExam();
  }

  logout(){
    const enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
    this.generalSvc.logoutUser(enetsecure);
  }
}
